import siteSearch from "./_site-search";

const shareLinks = {

    elements: {},

    cacheDom()
    {
        this.elements.shareLinks = document.querySelectorAll('.js-share');
    },

    bind()
    {
        if( this.elements.shareLinks )
        {
            [].forEach.call(this.elements.shareLinks, function(element){
                element.addEventListener('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    
                    window.open(
                        element.getAttribute('href'),
                        'socialWindow',
                        'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480'
                    );
                });
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default shareLinks;